import { useState, useEffect } from "react";
import { ReactComponent as CollapseIcon } from "../../../images/box-collapser.svg";
import { ReactComponent as ArrowIcon } from "../../../images/arrow-small-left.svg";
import Table from "components/elements/Table";
import Select from "components/elements/Select";
import IconInput from "components/elements/IconInput";
import DateInput from "components/elements/DateInput";
import Toggle from "components/elements/Toggle";
import { useOutletContext } from "react-router-dom";
import {
  CLIENT_BROADCASTER,
  USER_BUSINESS_ADMIN,
  USER_CLIENT_ENDUSER,
} from "core/Constants";
import Modal from "components/elements/Modal";
import utility from "core/Utils";
import dataProvider from "core/DataProvider";
import { CLIENT_AGENCY } from "core/Constants";
import { CLIENT_ADVERTISER } from "core/Constants";
import { USER_SUPERADMIN } from "core/Constants";
import { toast } from "react-hot-toast";
import Exporter from "components/elements/Exporter";
import SpotMultiSelect from "components/elements/SpotMultiSelect";

const headerMap = {
  sel_chk:"  ",
  channel: "Channel Name",
  adv_date: "Adv Date",
  brandcategory: "Brand Category",
  advertiser: "Advertiser",
  brandname: "Brand Name",
  captions: "Captions",
  breaknumber: "Break",
  positioninbreak: "Position in break",
  countinbreak: "Count in break",
  combinedpositioninbreak: "Combined position in break",
  commercial_program_name: "Commercial program name",
  program_theme: "Program Theme",
  commercial_program_start_time: "Commercial Program Start Time",
  adv_language: "Adv language",
  adv_start_time: "Adv start time",
  adv_end_time: "Adv end time",
  adv_duration: "Adv duration",
};

const headerMap_ica = {
  sel_chk:"  ",
  channel: "Channel Name",
  adv_date: "Adv Date",
  brandcategory: "Brand Category",
  advertiser: "Advertiser",
  brandname: "Brand Name",
  captions: "Captions",
  adv_language: "Adv language",
  adv_start_time: "Adv start time",
  adv_end_time: "Adv end time",
  adv_duration: "Adv duration",
};

let exportHeaders = [
  { label: "BRAND", key: "brandname" },
  { label: "CHANNELNAME", key: "channel" },
  { label: "CATEGORY", key: "brandcategory" },
  { label: "PROGRAM DATE", key: "adv_date" },
  { label: "PROGRAM START TIME", key: "commercial_program_start_time" },
  { label: "PROGRAM NAME", key: "commercial_program_name" },
  { label: "AD START TIME", key: "adv_start_time" },
  { label: "AD DURATION", key: "adv_duration" },
  { label: "BREAK NO.", key: "breaknumber" },
  { label: "AD POSITION IN BREAK", key: "positioninbreak" },
  { label: "TOTAL ADS IN BREAK", key: "countinbreak" },
  { label: "AD LANGUAGE", key: "adv_language" },
  { label: "AD THEME", key: "captions" },
  { label: "PREVIOUS AD", key: "previous_spot" },
  { label: "NEXT AD", key: "next_spot" },
  { label: "AD SR.NO.", key: "positioninbreak" },
  { label: "TOTAL ADS IN PROGRAM", key: "totalbreakcountperprogram" },
  { label: "ADVERTISER NAME", key: "advertiser" },
  { label: "SPOT ID", key: "spotid" },
  { label: "DAY OF PRORAM AIRED", key: "telecastday" },
  { label: "REPORTING DATE", key: "reporting_date" },
  { label: "AD END TIME", key: "adv_end_time" },
];

let exportHeaders_ica = [
  { label: "BRAND", key: "brandname" },
  { label: "CHANNELNAME", key: "channel" },
  { label: "CATEGORY", key: "brandcategory" },
  { label: "PROGRAM DATE", key: "adv_date" },
  { label: "AD START TIME", key: "adv_start_time" },
  { label: "AD DURATION", key: "adv_duration" },
  { label: "AD LANGUAGE", key: "adv_language" },
  { label: "AD THEME", key: "captions" },
  { label: "ADVERTISER NAME", key: "advertiser" },
  { label: "DAY OF PRORAM AIRED", key: "telecastday" },
  { label: "AD END TIME", key: "adv_end_time" },
];

let durations = [];
for (let i = 1; i < 121; i++) {
  durations.push({ value: i, label: `${i} sec` });
}

const MonitoringReport = () => {
  const [spotCount, setSpotCount] = useState(0);
  const [channelCount, setChannelCount] = useState(0);
  const [advertiserCount, setAdvertiserCount] = useState(0);
  const [brandCount, setBrandCount] = useState(0);
  const [data, setData] = useState([]);

  const [commonSegmentCollapsed, setCommonSegmentCollapsed] = useState(false);
  const [extraSegmentCollapsed, setExtraSegmentCollapsed] = useState(true);
  const [formCollapsed, setFormCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  const [columns, setColumns] = useState(utility.optionFromObject(headerMap));
  const [selectedColumns, setSelectedColumns] = useState(
    utility.optionFromObject(headerMap)
  );
  const [showColModal, setShowColModal] = useState(false);
  const [search, setSearch] = useState("");
  const [performSearch, setPerformSearch] = useState(false);
  const [exportFormat, setExportFormat] = useState({
    value: "csv",
    label: "CSV",
  });

  const [group, setGroup] = useState(null);
  const [groups, setGroups] = useState([]);
  const [groupDetails, setGroupDetails] = useState(null);
  const [client, setClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [advertiser, setAdvertiser] = useState([]);
  const [advertisers, setAdvertisers] = useState([]);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [channel, setChannel] = useState(null);
  const [channels, setChannels] = useState([]);
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [caption, setCaption] = useState("");
  const [program, setProgram] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [duration, setDuration] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [fileID, setFileID] = useState(null);
 const [isica, setIsICA] = useState(false);
 const [grp_ica, setGrpIca] = useState('hide');
 const [exportHeaders_flag,setExportHeader]=useState('exportHeaders');
  const token = useOutletContext();
const [selectedRows, setSelectedRows] = useState([]);
const [selectedRowsPDF, setSelectedRowsPDF] = useState([]);
  const handleSearchKeyDown = e => {
    if (e.keyCode == 13) {
      setPerformSearch(true);
    }
  };

  const getGroups = async () => {
    let d = await dataProvider.network.get("min-master/groups");
    if (d) {
      for (let i = 0; i < d.length; i++) {
        d[i] = { value: d[i].id, label: d[i].name };
      }

      utility.sortBy(d, "label");

      setGroups(d);
    } else {
      toast.error("Failed to load groups");
    }
  };

  const getGroupDetails = async () => {
    try {
      let d = await dataProvider.network.get("group?id=" + group.value);
      setGroupDetails(d);

      if (d && d.client_type === CLIENT_BROADCASTER) {
        getChannels();
      }
      if (d.is_ica){
      setGrpIca('show');
     // handleSwitchToICA(headerMap_ica);
      }else{
        setIsICA(false);
        setGrpIca('hide');
      //  handleSwitchToICA(headerMap);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch group details");
    }
  };

  const getClients = async () => {
    let d = await dataProvider.network.get(
      "min-master/clients?group-id=" + group.value
    );
    if (d) {
      d = d.map(x => {
        return { label: x.name, value: x.id };
      });

      utility.sortBy(d, "label");

      setClients(d);
    } else {
      alert("failed to fetch clients");
    }
  };

  const getAdvertisers = async () => {
    try {
      let advs = await dataProvider.network.get(
        "report/advertisers/" + client.value
      );
      advs = advs.map(x => ({ value: x.id, label: x.name }));

      utility.sortBy(advs, "label");

      setAdvertisers(advs);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load advertisers");
    }
  };

  const getCategories = async () => {
    if (token.type === USER_CLIENT_ENDUSER) {
      try {
        let cats = await dataProvider.network.post(`min-master/brandcategory`, {
          advertisers: advertiser.map(x => x.value),
        });
        cats = cats.map(x => ({
          label: x.name,
          value: x.id,
        }));

        utility.sortBy(cats, "label");

        setCategories(cats);
      } catch (error) {
        console.error(error);
        toast.error("Failed to get categories");
      }
    } else {
      try {
        let cats = await dataProvider.network.post(`masters/brand-category`, {
          advertisers: advertiser.map(x => x.value),
        });
        cats = cats.map(x => ({
          label: x.brandcategory,
          value: x.brandcategorycode,
        }));

        setCategories(cats);
      } catch (error) {
        console.error(error);
        toast.error("Failed to get categories");
      }
    }
  };

  const getBrands = async () => {
    try {
      let brands = await dataProvider.network.post(`min-master/brand`, {
        advertisers: advertiser.map(x => parseInt(x.value)),
        categories: category.map(x => parseInt(x.value)),
      });
      brands = brands.map(x => ({ label: x.name, value: x.id }));

      utility.sortBy(brands, "label");

      setBrands(brands);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load brands");
    }
  };

  const getChannels = async () => {
    let clientId = token.client_id
      ? token.client_id
      : client && client.value
      ? client.value
      : null;

    if (!clientId) {
      return;
    }

    let url = clientId
      ? `masters/client-channels/${clientId}`
      : `min-masters/channels`;

    try {
      let channels = await dataProvider.network.get(url);
      channels = channels.map(x => ({ value: x.id, label: x.name }));

      utility.sortBy(channels, "label");

      setChannels(channels);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch channels");
    }
  };

  const getPrograms = async () => {
    try {
      let channelParams = channel.map(x => `channel=${x.value}`);
      let programs = await dataProvider.network.get(
        `min-master/program?${channelParams.join("&")}`
      );

      programs = programs.map(x => ({ value: x.id, label: x.name }));
      setPrograms(programs);
    } catch (error) {
      console.error(error);
      toast.error("Faile to fetch programs");
    }
  };
  const handleSwitchToICA = (hmap) => {
  const newCols = utility.optionFromObject(hmap);

  setColumns(newCols);
  setSelectedColumns(newCols);
};

  const submit = async e => {
    e.preventDefault();

    // validations
    try {
      if (!token.client_id) {
        // internal users
        if (!group) {
          throw new Error("Please select group");
        }
        if (!client) {
          throw new Error("Please select client");
        }
        if (!periodFrom) {
          throw new Error("Please select from date");
        }
        if (!periodTo) {
          throw new Error("Please select to date");
        }

        if (groupDetails && groupDetails.client_type === CLIENT_BROADCASTER) {
          if (!channel) {
            throw new Error("Please select channel");
          }
        } else if (!advertiser.length) {
          throw new Error("Please select advertiser");
        }
      } else {
        // client users
        // for advertiser/agency
        if ([CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)) {
          if (!periodFrom) {
            throw new Error("Please select from date");
          }
          if (!periodTo) {
            throw new Error("Please select to date");
          }
          if (!advertiser.length) {
            throw new Error("Please select advertiser");
          }
        }

        // for agency, broadcaster
        if ([CLIENT_BROADCASTER].includes(token.client_type)) {
          if (!periodFrom) {
            throw new Error("Please select from date");
          }
          if (!periodTo) {
            throw new Error("Please select to date");
          }
          if (!channel) {
            throw new Error("Please select channel");
          }
        }
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }

    setLoading(true);

    let data = {
      client_id: client.value,
      period_from: periodFrom,
      period_to: periodTo,
      advertiser: advertiser.length ? advertiser.map(x => x.value) : [],
      categories: category && category.length ? category.map(x => x.value) : [],
      brands: brand && brand.length ? brand.map(x => x.value) : [],
      channels: channel && channel.length ? channel.map(x => x.value) : [],
      caption: caption,
      program: program && program.value,
      durations: duration && duration.length ? duration.map(x => x.value) : [],
      start_time: utility.getSecondsFromTime(startTime),
      end_time: utility.getSecondsFromTime(endTime),
      ica_flag:isica,
    };

    try {
      let resp = await dataProvider.network.post("monitoring-report", data);
      let records = resp.data;

      setFileID(resp.file_id);
      setData(records);
      setFormCollapsed(true);

      let spotCount = records.length;
      let channels = [];
      let brands = [];

      for (let i = 0; i < records.length; i++) {
        if (!channels.includes(records[i].channel)) {
          channels.push(records[i].channel);
        }
        if (!brands.includes(records[i].brandname)) {
          brands.push(records[i].brandname);
        }
      }
       if(isica){
        handleSwitchToICA(headerMap_ica);
        setExportHeader(exportHeaders_ica);
       }else{
         handleSwitchToICA(headerMap);
         setExportHeader(exportHeaders);
       }
      setSpotCount(spotCount);
      setChannelCount(channels.length);
      setBrandCount(brands.length);
      setAdvertiserCount(1);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load monitoring report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGroups();

    if (
      [CLIENT_ADVERTISER, CLIENT_AGENCY, CLIENT_BROADCASTER].includes(
        token.client_type
      )
    ) {
      setGroup({ value: token.group_id, label: "" });
      setClient({ value: token.client_id, label: "" });
      console.log('token',token);
      if(token.is_ica){
      setGrpIca('show');
      }else{
setGrpIca('hide');
      }
      getChannels();
    }
  }, []);

  useEffect(() => {
    if (group && group.value) {
      getClients();
      getGroupDetails();
    }
  }, [group]);

  useEffect(() => {
    if (client && client.value) {
      if (groupDetails && groupDetails.client_type === CLIENT_BROADCASTER) {
        getChannels();
      }
      getAdvertisers();
    }
  }, [client]);

  useEffect(() => {
    if (advertiser.length) {
      getCategories();
      getChannels();
    }
  }, [advertiser]);

  useEffect(() => {
    if (category && category.length) {
      getBrands();
    }
  }, [category]);

  useEffect(() => {
    if (brand && brand.length) {
      getChannels();
    }
  }, [brand]);

  useEffect(() => {
    if (channel && channel.length) {
      getPrograms();
    }
  }, [channel]);

  const permissionCheck = key => {
    let show = false;

    if (key === "advertiser_select") {
      if ([CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)) {
        show = true;
      }

      if ([USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type)) {
        show = true;

        if (groupDetails && groupDetails.client_type === CLIENT_BROADCASTER) {
          show = false;
        }
      }
    }

    if (key === "advertiser_count") {
      if (
        [USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type) ||
        [CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)
      ) {
        show = true;
      }
    }

    if (key === "brand_count") {
      if (
        [USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type) ||
        [CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)
      ) {
        show = true;
      }
    }

    if (key === "brand_select") {
      if ([CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)) {
        show = true;
      }

      if ([USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type)) {
        show = true;
        if (groupDetails && groupDetails.client_type === CLIENT_BROADCASTER) {
          show = false;
        }
      }
    }

    if (key === "category_select") {
      if ([CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)) {
        show = true;
      }

      if ([USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type)) {
        show = true;
        if (groupDetails && groupDetails.client_type === CLIENT_BROADCASTER) {
          show = false;
        }
      }
    }

    if (key === "extra_segment") {
      if (
        [USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type) ||
        [CLIENT_ADVERTISER, CLIENT_AGENCY].includes(token.client_type)
      ) {
        show = true;
      }
    }

    if (["group_select", "client_select"].includes(key)) {
      if ([USER_SUPERADMIN, USER_BUSINESS_ADMIN].includes(token.type)) {
        show = true;
      }
    }

    return show;
  };

  const colModal = (
    <Modal onClose={() => setShowColModal(false)}>
      <h3>Select Columns</h3>
      <div className="full-row" style={{ width: "50vw", marginTop: "2rem" }}>
        <Select
          isMulti
          value={selectedColumns}
          options={columns}
          placeholder="Select columns to show"
          onChange={val => setSelectedColumns(val)}
        />
      </div>
    </Modal>
  );

  let filteredData = [];
  if (data.length) {
    for (let i = 0; i < data.length; i++) {
      let toPush = true;

      if (performSearch && search.length > 2) {
        let searchableString = "";
        let searchString = search.toLowerCase();
        let keys = Object.keys(data[i]);

        for (let j = 0; j < keys.length; j++) {
          if (typeof data[i][keys[j]] == "string") {
            searchableString += data[i][keys[j]].toLowerCase();
          }

          if (typeof data[i][keys[j]] == "number") {
            searchableString += String(data[i][keys[j]]);
          }
        }

        if (!searchableString.includes(searchString)) {
          toPush = false;
        }
      }

      if (toPush) {
        filteredData.push(data[i]);
      }
    }
  }

const dataWithUniqueId = filteredData.map((item, index) => ({
    ...item,
    unique_id: item.id ?? item.grievance_id ?? index + 1,
}));

const allSelected =
    dataWithUniqueId.length > 0 &&
    dataWithUniqueId.every((item) =>
        selectedRows.some(
            (row) => row.unique_id === item.unique_id
        )
    );

const handleSelectAll = (e) => {
    if (e.target.checked) {

        setSelectedRows((prev) => {
            const existingIds = new Set(
                prev.map((row) => row.unique_id)
            );

            const newRows = dataWithUniqueId.filter(
                (item) => !existingIds.has(item.unique_id)
            );

            return [...prev, ...newRows];
        });

        setSelectedRowsPDF((prev) => {
            const existingIds = new Set(prev);

            const newIds = dataWithUniqueId
                .map((item) => item.unique_id)
                .filter((id) => !existingIds.has(id));

            return [...prev, ...newIds];
        });

    } else {

        setSelectedRows((prev) =>
            prev.filter(
                (row) =>
                    !dataWithUniqueId.some(
                        (item) =>
                            item.unique_id === row.unique_id
                    )
            )
        );

        setSelectedRowsPDF((prev) =>
            prev.filter(
                (id) =>
                    !dataWithUniqueId.some(
                        (item) =>
                            item.unique_id === id
                    )
            )
        );
    }
};

const updatedFilteredData = dataWithUniqueId.map((item) => ({
  ...item,

  sel_chk: (
    <input
      type="checkbox"
      checked={selectedRows.some(
        (row) => row.unique_id === item.unique_id
      )}
      onChange={(e) => {
        if (e.target.checked) {
          setSelectedRows((prev) => [
            ...prev,
            item
          ]);

          setSelectedRowsPDF((prev) => [
            ...prev,
            item.unique_id
          ]);
        } else {
          setSelectedRows((prev) =>
            prev.filter(
              (row) => row.unique_id !== item.unique_id
            )
          );

          setSelectedRowsPDF((prev) =>
            prev.filter(
              (id) => id !== item.unique_id
            )
          );
        }
      }}
    />
  ),
}));
const tableHeaders = utility.objectFromOptions(selectedColumns);

tableHeaders.sel_chk = (
    <input
        type="checkbox"
        checked={allSelected}
        onChange={handleSelectAll}
    />
);
  const now = new Date();
  const datePart = now.toISOString().split("T")[0].replaceAll(/\-/g, "");
  const timePart = now.toTimeString().split(" ")[0].replaceAll(/\:/g, "");
  const random = utility.getRandomNumbers(10000, 99999);

  const fileName = `${datePart}${timePart}_${periodFrom}_${periodTo}_${random}`;

  let downloadFormats = [
    { value: "csv", label: "CSV" },
    { value: "xlsx", label: "XLSX" },
  ];

  if (advertiser.length < 2) {
    downloadFormats.push({
      value: "pdf",
      label: "PDF",
    });
  }

  return (
    <section id="monitoring-report">
      {showColModal && colModal}
      <div className="grey-box">
        <div className="left">
          <h3>Monitoring Report</h3>
          <h4>Reports &gt; Monitoring Report</h4>
        </div>
        <div className="right">
          {loading && (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          )}
          <div className="stat" >
            <span>{selectedRows.length}</span>
   <span>Selected Spots</span>
    </div>
          <div className="stat">
            <span>{spotCount}</span>
            <span>Spot Count</span>
          </div>
          <div className="stat">
            <span>{channelCount}</span>
            <span>Channels</span>
          </div>
          {permissionCheck("advertiser_count") && (
            <div className="stat">
              <span>{advertiserCount}</span>
              <span>Advertiser</span>
            </div>
          )}
          {permissionCheck("brand_count") && (
            <div className="stat">
              <span>{brandCount}</span>
              <span>Brand</span>
            </div>
          )}
        </div>
      </div>
      <div className="flex mtop">
        <div
          className={formCollapsed ? "form-wrapper collapsed" : "form-wrapper"}
        >
          <div
            className={
              commonSegmentCollapsed ? "form-segment collapsed" : "form-segment"
            }
          >
            <div
              className="segment-head"
              onClick={e => setCommonSegmentCollapsed(!commonSegmentCollapsed)}
            >
              <h6>Common</h6>
              <span>
                <CollapseIcon />
              </span>
            </div>
            <div className="segment-body">
              {permissionCheck("group_select") && (
                <Select
                  options={groups}
                  value={group}
                  onChange={val => setGroup(val)}
                  placeholder="Group"
                />
              )}
              {permissionCheck("client_select") && (
                <Select
                  options={clients}
                  value={client}
                  onChange={val => setClient(val)}
                  placeholder="Client"
                />
              )}
              <DateInput
                value={periodFrom}
                onChange={val => setPeriodFrom(val)}
                placeholder="Period from"
              />
              <DateInput
                value={periodTo}
                onChange={val => setPeriodTo(val)}
                placeholder="Period to"
              />
{grp_ica === "show" && (
              <div style={{marginTop:"15px"}} >
              <span  style={{float:"left", color: "var(--black-shade-2)",fontSize: "0.875rem",paddingRight:"10%",marginTop:"5px"}}>
              ICA SPOTS
            </span>
            <Toggle style={{float:"right",marginLeft:"10px"}}
               options={["Yes", "No"]}
              onChange={val => setIsICA(val === "Yes")}
              defaultLeft={isica}
            /></div> )}
              {permissionCheck("advertiser_select") && (
                <SpotMultiSelect
                  options={advertisers}
                  value={advertiser}
                  onChange={setAdvertiser}
                  placeholder="Advertiser"
                />
              )}
              {permissionCheck("category_select") && (
                <Select
                  isMulti
                  options={categories}
                  value={category}
                  onChange={val => setCategory(val)}
                  placeholder="Category"
                />
              )}
              {permissionCheck("brand_select") && (
                <Select
                  isMulti
                  options={brands}
                  value={brand}
                  onChange={val => setBrand(val)}
                  placeholder="Brand"
                />
              )}
              <Select
                isMulti
                options={channels}
                value={channel}
                onChange={val => setChannel(val)}
                placeholder="Channel"
              />
            </div>
          </div>
          {permissionCheck("extra_segment") && (
            <div
              className={
                extraSegmentCollapsed
                  ? "form-segment collapsed"
                  : "form-segment"
              }
            >
              <div
                className="segment-head"
                onClick={e => setExtraSegmentCollapsed(!extraSegmentCollapsed)}
              >
                <h6>Extras</h6>
                <span>
                  <CollapseIcon />
                </span>
              </div>
              <div className="segment-body">
                <input
                  type="text"
                  value={caption}
                  onChange={e => setCaption(e.target.value)}
                  placeholder="Caption"
                />
                <Select
                  options={programs}
                  value={program}
                  onChange={val => setProgram(val)}
                  placeholder="Program"
                />
                <Select
                  isMulti
                  options={durations}
                  value={duration}
                  onChange={val => setDuration(val)}
                  placeholder="Duration"
                />
                <input
                  className="monitoring-start-time"
                  type="time"
                  step="1"
                  value={startTime}
                  onChange={e => setStartTime(e.target.value)}
                  placeholder="Start Time"
                />
                <input
                  className="monitoring-end-time"
                  type="time"
                  step="1"
                  value={endTime}
                  onChange={e => setEndTime(e.target.value)}
                  placeholder="End Time"
                />
              </div>
            </div>
          )}
          <button onClick={submit}>Submit</button>
          <div
            className="collapser"
            onClick={e => setFormCollapsed(!formCollapsed)}
          >
            <ArrowIcon />
          </div>
        </div>
        <div className="results-wrapper flex-full">
          <div className="head flex flex-v-center">
            <h3>Results</h3>
            <div className="right">
              <div className="flex flex-v-center">

                <div className="el">
                  <input
                    type="text"
                    readOnly
                    placeholder="Select Columns"
                    onClick={e => {
                      e.preventDefault();
                      setShowColModal(true);
                    }}
                  />
                </div>
                <div className="el">
                  <IconInput
                    value={search}
                    onKeyDown={handleSearchKeyDown}
                    onChange={e => {
                      setPerformSearch(false);
                      setSearch(e.target.value);
                    }}
                    placeholder="Search"
                    icon="search"
                  />
                </div>
                <div className="el">
                  <Select
                    value={exportFormat}
                    onChange={val => {
                      setExportFormat(val);
                    }}
                    options={downloadFormats}
                    placeholder="Format"
                  />
                </div>
                <Exporter
                  format={exportFormat.value}
                  data={selectedRows && selectedRows.length > 0 ? selectedRows : data} icaFlag={isica}
                  headers={exportHeaders_flag} selectedPDF={selectedRowsPDF}
                  filename={`${fileName}.${exportFormat.value}`}
                  fileID={fileID}
                  selData={selectedRows && selectedRows.length > 0 ? 1 : 0}
                  clientID={
                    token.client_id
                      ? token.client_id
                      : client && client.value
                      ? client.value
                      : null
                  }
                />
              </div>
            </div>
          </div>
          <div className="results">
            <Table
              headers={tableHeaders}
              data={updatedFilteredData}
               search={search}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MonitoringReport;
